import React from 'react';
import FormContext, { type Context } from './FormContext';
export default function useFormContext<T = any>() {
  return React.useContext<Context<T>>(FormContext);
}